import { AIRLINES } from '../constants';

export const findDefaultFlight = (flights = []) => {
  if (!(flights && flights.length)) {
    return null;
  }

  const availableFlights = filterFullFlights(flights);
  // const directflights = filterConnectingFlights(availableFlights);
  // const targetFlights = directflights.length ? directflights : availableFlights;
  const res = findLowestPriceFlight(availableFlights);
  return res;
};

const filterFullFlights = (flights) => {
  return flights.filter((f) => f.seatStatus === 'Vacant');
};

// const filterConnectingFlights = (flights) => {
//   return flights.filter((f) => !(f.connectingFlights && f.connectingFlights.length));
// };

const findLowestPriceFlight = (flights) => {
  const lowestPriceFlight = flights.reduce((pre, current) => {
    return current.price < pre.price ? current : pre;
  }, flights[0]);

  return lowestPriceFlight;
};

export const getFlightNameAndLogoPath = (flight) => {
  const {
    id,
    carrierName,
    airline,
  } = flight;

  let flightName = '';
  let logoPath = '';
  if (airline === AIRLINES.ana){
    switch (carrierName){
    case 'ANJ':
    case 'AN6':
    case 'ADN':
    case 'AMN':
    case 'ANF':
    case 'ANO':
      flightName = `ANA${id.toString().padStart(3, '0')}`;
      break;
    default: flightName = `${carrierName}${id.toString().padStart(3, '0')}`; break;
    }

    switch (carrierName){
    case 'ADO': logoPath = 'airdo.png'; break;
    case 'SNA': logoPath = 'solaseedair.png'; break;
    case 'SFJ': logoPath = 'starflyer.png'; break;
    default: logoPath = 'Ana.svg'; break;
    }
  } else if (airline === AIRLINES.jal){
    if (carrierName === 'JAL' || carrierName === 'JTA' || carrierName === 'RAC') {
      logoPath = `${airline}.jpg`;
    }

    flightName = `${carrierName}${id.toString().padStart(3, '0')}`;
  }

  return { flightName, logoPath };
};

export const getCarrierName = (flight) => {
  let res = '';

  if (!flight) {
    return res;
  }

  const { carrierName, airline } = flight;

  if (airline === AIRLINES.ana){
    switch (carrierName){
    case 'ANJ':
    case 'AN6':
    case 'ADN':
    case 'AMN':
    case 'ANF':
    case 'ANO':
      res = 'ANA';
      break;
    default: res = carrierName; break;
    }
  } else {
    res = carrierName;
  }

  return res;
};

export const makeClassJFlight =(flight) => {
  const {
    upgrades,
    connectingFlights,
  } = flight;
  const classJPrice = upgrades[0].price;
  const classJSeatStatus = upgrades[0].seatStatus;
  const classJBookingClass = upgrades[0].bookingClass;
  const classJFareDisplayClass = upgrades[0].fareDisplayClass;
  const classJChildPrice = upgrades[0].childPrice;
  const classJReservationCode = upgrades[0].reservationCode;
  const classJChildReservationCode = upgrades[0].childReservationCode;
  const _connectingFlights = connectingFlights ? connectingFlights.map((c) => ({
    ...c,
    bookingClass: c.upgrades[0].bookingClass,
    fareDisplayClass: c.upgrades[0].fareDisplayClass,
    price: c.upgrades[0].price,
    childPrice: c.upgrades[0].childPrice,
    seatStatus: c.upgrades[0].seatStatus,
    reservationCode: c.upgrades[0].reservationCode,
    childReservationCode: c.upgrades[0].childReservationCode,
  })) : undefined;
  const classJFlight = {
    ...flight,
    bookingClass: classJBookingClass,
    fareDisplayClass: classJFareDisplayClass,
    price: classJPrice,
    childPrice: classJChildPrice,
    seatStatus: classJSeatStatus,
    reservationCode: classJReservationCode,
    childReservationCode: classJChildReservationCode,
    connectingFlights: _connectingFlights,
  };

  return classJFlight;
};

export const parseFlightNameAna = (flightName) => {
  if (typeof flightName !== 'string') {
    return false;
  }

  return flightName.includes('ANA')
    || flightName.includes('ANJ')
    || flightName.includes('AN6')
    || flightName.includes('ADN')
    || flightName.includes('AMN')
    || flightName.includes('ANF')
    || flightName.includes('ANO');
};

export const isSameFlightNameByUrlParam = (flight, flightNameByUrlParam) => {
  if (typeof flight === 'undefined') {
    return false;
  }

  if (typeof flightNameByUrlParam !== 'string') {
    return false;
  }

  let _carrierName = flight.carrierName;

  switch (_carrierName){
  case 'ANJ':
  case 'AN6':
  case 'ADN':
  case 'AMN':
  case 'ANF':
  case 'ANO':
    _carrierName = 'ANA';
    break;
  default:
    break;
  }

  const {
    carrierName: carrierNameByUrl,
    id: idByUrl,
  } = getCarrierNameAndIdFromFlightName(flightNameByUrlParam);

  return _carrierName === carrierNameByUrl && isSameId(flight.id, idByUrl);
};

const getCarrierNameAndIdFromFlightName = (flightName) => {
  if (typeof flightName !== 'string') {
    return ['', ''];
  }

  const carrierName = flightName.substr(0, 3);
  const id = flightName.substr(3);
  return { carrierName, id };
};

const isSameId = (id1, id2) => {
  return id1 === id2
    || `0${id1}` === id2
    || `00${id1}` === id2
    || id1 === `0${id2}`
    || id1 === `00${id2}`
    || `0${id1}` === `0${id2}`
    || `00${id1}` === `00${id2}`
    || `0${id1}` === `00${id2}`
    || `00${id1}` === `0${id2}`;
};
